/** 臻享卡当前使用场景枚举，用来判断展示某个具体的卡片 */
export enum ZhenXiangCardSceneEnum {
  /** 臻享卡-app端内 */
  ZHEN_XIANG_CARD_INEER = '01',
  /** 臻享卡-端外h5 */
  ZHEN_XIANG_CARD_OUT_FLOW = '02',
  /** 臻享卡-App实验版(上下交互)：https://hellobike.yuque.com/yxr77w/oyyz8n/mh75aixd1qzgucp8 */
  ZHEN_XIANG_CARD_EXP = '03',
  /** 臻享卡-合规样式 */
  ZHEN_XIANG_CARD_INEER_ALL_CARD = '04',
}

/** 权益弹窗展示场景 */
export enum RightTipsDialogSceneEnum {
  /** 需要购买权益，但是权益数据获取为空 */
  GET_RIGHTS_DATA_NULL = 1,
  /** 提现环节权益入参校验失败 */
  LOAN_RIGHT_PARAMS_ERROR = 2,
  /** 权益接口网络查询异常 */
  NET_ERROR = 3,
  /** 提现环节权益入参校验失败,并且命中异常兜底流程后，降级兼容 */
  LOAN_RIGHT_PARAMS_ERROR_AND_CATCH = 4
}

/** 权益弹窗动作类型 */
export enum RightTipsDialogActionEnum {
  /** 刷新权益接口数据 */
  REFRESH_RIGHTS_DATA = 1,
  /** 刷新当前页面 */
  REFRESH_PAGE = 2,
}


/** 权益弹窗埋点场景 */
export enum RightTipsDialogUbtEnum {
  /** 曝光 */
  EXPOSE = 1,
  /** 点击 */
  CLICK = 2
}
